import { defineComponent as I, mergeModels as h, useModel as M, computed as F, useTemplateRef as C, createElementBlock as H, openBlock as R, Fragment as W, createVNode as u, unref as d, withCtx as r, renderSlot as m, mergeProps as y, createTextVNode as z, nextTick as P } from "vue";
import K from "../Menu/Menu.vue2.js";
import L from "../MenuToggle/MenuToggle.vue2.js";
import N from "../../helpers/PassThrough.vue2.js";
import V from "../../helpers/FloatingUi.vue2.js";
import { useHtmlElementFromVNodes as A } from "../../use/index.js";
import { useEventListener as b } from "@vueuse/core";
import { useOUIAProps as U } from "../../helpers/ouia.js";
const X = /* @__PURE__ */ I({
  name: "PfSelect",
  inheritAttrs: !1,
  __name: "Select",
  props: /* @__PURE__ */ h({
    minWidth: {},
    zIndex: {},
    placement: { default: "bottom" },
    appendTo: {},
    focusToggleOnSelect: { type: Boolean },
    noFocusFirstItemOnOpen: { type: Boolean },
    closeOnKeys: { default: () => ["Escape", "Tab"] },
    disabled: { type: Boolean },
    fullHeight: { type: Boolean },
    fullWidth: { type: Boolean },
    variant: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ h(["select"], ["update:open"]),
  setup(p, { emit: S }) {
    const n = p, T = U({ id: n.ouiaId, safe: n.ouiaSafe }), l = M(p, "open"), B = S, O = F(() => n.placement !== "top" && n.placement !== "bottom" ? n.placement : `${n.placement}-start`), f = C("menuRef"), { element: o, findReference: $ } = A(), w = (e) => {
      var t, a, i, s;
      l.value && ((a = (t = f.value) == null ? void 0 : t.el) != null && a.contains(e.target) || (i = o.value) != null && i.contains(e.target)) && n.closeOnKeys.includes(e.key) && (e.preventDefault(), l.value = !1, o.value instanceof HTMLElement && ((s = o.value) == null || s.focus()));
    }, k = (e) => {
      var t, a, i, s;
      l.value && !n.noFocusFirstItemOnOpen && ((t = o.value) != null && t.contains(e.target)) && P(() => {
        var v, g;
        const c = (g = (v = f.value) == null ? void 0 : v.el) == null ? void 0 : g.querySelector("li button:not(:disabled),li input:not(:disabled)");
        c && c.focus();
      }), l.value && !((a = o.value) != null && a.contains(e.target)) && !((s = (i = f.value) == null ? void 0 : i.el) != null && s.contains(e.target)) && (l.value = !1);
    };
    function E(e) {
      var t;
      B("select", e), n.focusToggleOnSelect && o.value instanceof HTMLElement && ((t = o.value) == null || t.focus());
    }
    return b(window, "keydown", w), b(window, "click", k), (e, t) => (R(), H(W, null, [
      u(N, { onChildren: d($) }, {
        default: r(() => [
          m(e.$slots, "toggle", {}, () => [
            u(L, y(d(T), {
              expanded: l.value,
              "onUpdate:expanded": t[0] || (t[0] = (a) => l.value = a),
              disabled: e.disabled,
              variant: e.variant,
              "full-height": e.fullHeight,
              "full-width": e.fullWidth
            }), {
              default: r(() => [
                m(e.$slots, "label", {}, () => [
                  t[1] || (t[1] = z(" Select a value "))
                ])
              ]),
              _: 3
            }, 16, ["expanded", "disabled", "variant", "full-height", "full-width"])
          ])
        ]),
        _: 3
      }, 8, ["onChildren"]),
      u(V, {
        hidden: !l.value,
        "teleport-to": e.appendTo,
        reference: d(o),
        placement: O.value,
        "z-index": e.zIndex,
        flip: ""
      }, {
        default: r(() => [
          u(K, y({ ref: "menuRef" }, e.$attrs, {
            style: { "--pf-v6-c-menu--MinWidth": e.minWidth },
            onSelect: E
          }), {
            default: r(() => [
              m(e.$slots, "default")
            ]),
            _: 3
          }, 16, ["style"])
        ]),
        _: 3
      }, 8, ["hidden", "teleport-to", "reference", "placement", "z-index"])
    ], 64));
  }
});
export {
  X as default
};
